import { Link } from "react-router-dom";
import { ArrowSquareOut, Wrench } from "@phosphor-icons/react";
import { Section, Card, KPI, useMoney } from "./shared";

export default function RepairsSection({ r }) {
  const { fmt } = useMoney();
  const rp = r.repairs;
  const s = r.summary;
  const hasAny = rp.tickets_created || rp.notes_created || rp.notes_paid || rp.in_workshop_now || rp.closed_in_month;
  return (
    <Section id="reparaciones" num={8} title="Reparaciones" desc="Tickets del Taller y notas de reparación. 'Cobradas' cuenta por fecha en que se liquidó la nota; 'Venta de reparación' (arriba) cuenta por fecha de nota."
      right={<Link to="/hospital" className="no-print inline-flex items-center gap-1 text-xs font-semibold text-[#002FA7] hover:underline" data-testid="mr-repairs-link">Ir al Taller <ArrowSquareOut size={12} /></Link>}>
      <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 gap-3" data-testid="mr-repairs-kpis">
        <KPI label="Tickets creados" value={rp.tickets_created} sub="en el mes" small testid="kpi-rep-tickets" />
        <KPI label="Notas de reparación" value={rp.notes_created} sub="creadas en el mes" small testid="kpi-rep-notes" />
        <KPI label="Reparaciones cobradas" value={rp.notes_paid} sub="notas liquidadas" tone="good" small testid="kpi-rep-paid" />
        <KPI label="Cobrado por reparaciones" value={fmt(rp.paid_total_mxn)} tone="primary" small testid="kpi-rep-paid-total" />
        <KPI label="Venta de reparación" value={fmt(s.repair_sales_mxn)} sub={`${s.repair_notes_count} nota(s) del mes`} small testid="kpi-rep-sales" />
        <KPI label="En taller ahora" value={rp.in_workshop_now} sub={`${rp.created_in_month_still_open} de este mes`} tone={rp.in_workshop_now > 0 ? "warn" : "muted"} small testid="kpi-rep-open" />
        <KPI label="Cerrados en el mes" value={rp.closed_in_month} small testid="kpi-rep-closed" />
      </div>
      {!hasAny && (
        <Card testid="mr-repairs-empty">
          <div className="flex items-center gap-3 text-xs text-zinc-500">
            <Wrench size={20} className="text-zinc-300" />
            Sin actividad de taller en este periodo.
          </div>
        </Card>
      )}
    </Section>
  );
}
